import type { ReactElement } from "react"
import React from "react"
import _t from "@core/i18n"
import ProductSummaryMol from "@onestore/hel/dist/components/molecules/ProductSummaryMol"
import useBreakpoint from "@onestore/hel/dist/hooks/useBreakpoint"
import FormButton from "@gatsby-plugin-generic-page/components/FormButton"
import type { Formily } from "@gatsby-plugin-generic-page/fragments/formily"
import { getAnchorProperties } from "~/lib/dom"
import isEmpty from "~/lib/isEmpty"
import { COMPONENT_ID } from "~/types/component"

interface SecondaryButtonProps {
  formilyForm?: Formily[]
}

export function SecondaryButton({
  formilyForm,
}: SecondaryButtonProps): ReactElement<SecondaryButtonProps> | null {
  const isMediumScreenUp = useBreakpoint("medium")

  if (!isMediumScreenUp) {
    return null
  }

  if (!isEmpty(formilyForm)) {
    return (
      <FormButton
        form={formilyForm}
        text={_t("marketplace.contactButton")}
        title={_t("marketplace.contactButton")}
        color="secondary"
        variant="outlined"
        size="big"
        isExpanded
      />
    )
  }

  const secondaryButtonAnchor = getAnchorProperties(COMPONENT_ID.PRODUCT_BUNDLE)

  return (
    <ProductSummaryMol.SecondaryButton
      onClick={secondaryButtonAnchor.onClick}
      text={_t("marketplace.viewBundle")}
      title={_t("marketplace.viewBundle")}
    />
  )
}
